import { Link, useLocation } from 'react-router-dom';

export function Header() {
  const { pathname } = useLocation();
  const isHomePage = pathname === '/';

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200">
      <div className="px-4 py-3 flex items-center justify-between">
        {!isHomePage && (
          <Link to="/" className="text-gray-600 hover:text-gray-900">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.75 19.5L8.25 12l7.5-7.5"
              />
            </svg>
          </Link>
        )}

        {isHomePage && (
          <>
            <div className="relative w-10 h-10">
              <img
                src="/logo.png"
                alt="Logo"
                className="w-full h-full object-contain"
              />
            </div>
            <Link
              to="/history-settings"
              className="text-sm font-medium text-gray-900 px-4 py-2 border border-gray-300 rounded-full hover:bg-gray-50 transition-colors"
            >
              History & Settings
            </Link>
          </>
        )}
      </div>
    </header>
  );
}
